/**
 * Get the QR code wrapper that we add to the Qala Save Share Cart popover via PHP. If it exists and we
 * have a QR Code available in the passed cartData, we create an img element and append it to the wrapper
 * with the QR Code as the src.
 *
 * @param {Object} cartData The data of the saved cart.
 *
 * @return {void}
 */
wp.hooks.addAction( 'qalaSaveShareCart.action.showSuccess', 'qalaQRCodes', function( cartData ) {
	const qrCodeWrapper = document.querySelector( '.js-qala-qr-codes-cart-share-img-wrapper' );

	if ( ! qrCodeWrapper ) {
		return;
	}

	const qrCode = cartData?.cartShareQRCode;

	if ( ! qrCode?.length || typeof qrCode !== 'string' ) {
		return;
	}

	const qrCodeEl = document.createElement( 'img' );
	qrCodeEl.classList.add( 'qala-qr-codes__cart-share-img' );
	qrCodeEl.classList.add( 'js-qala-qr-codes-cart-share-img' );
	qrCodeEl.src = qrCode;
	qrCodeWrapper.appendChild( qrCodeEl );
} );

/**
 * Remove our QR Code element when the Qala Save Share Cart popover is closed. This is because
 * a new cart is generated everytime the Save Share button is clicked, and we want a completely new
 * QR Code rendered and saved to the cart post.
 */
wp.hooks.addAction( 'qalaSaveShareCart.action.closePopup', 'qalaQRCodes', function() {
	const currentQRCode = document.querySelector( '.js-qala-qr-codes-cart-share-img' );
	currentQRCode?.remove();
} );
